/* eslint-disable import/prefer-default-export */
import * as React from 'react'
import * as styles from './user.activity.filter.styl'
import {
  DateRangePicker,
  DateRangeData
} from '@src/components/common/date.pickers'
import Select, { ValueType } from '@src/components/common/select'
import TextBox from '@src/components/common/text.box'
import { find } from 'lodash'
import * as Actions from '@src/redux/actions/userUsage.actions'
import type { FocusedInput } from '@datepicker-react/hooks'
import { useDispatch } from 'react-redux'
interface FilterColumn {
  value?: string
  label?: string
}
interface Props {
  showToastMessages: boolean
  useSearch: boolean
  query: string
  searchValue: string
  userName: string
  accountId: string
  selectedFilterColumn: string
  filterColumns: FilterColumn[]
  startTime: Date
  endTime: Date
  onFetchData: ({
    startTime,
    endTime
  }: {
    startTime: Date
    endTime: Date
  }) => void
}

export const UserActivityFilter: React.FC<Props> = React.memo(
  (props: Props) => {
    const {
      userName,
      accountId,
      query,
      showToastMessages,
      filterColumns,
      onFetchData,
      startTime,
      endTime,
      selectedFilterColumn,
      searchValue,
      useSearch
    } = props
    const dispatch = useDispatch()

    const [focusedInput] = React.useState<FocusedInput>(null)

    function onChangeFilterColumn(
      option: ValueType<FilterColumn> = {} as FilterColumn
    ) {
      const { value = null } = option as FilterColumn
      dispatch(
        Actions.onChangeFilterColumn(
          {
            query,
            userName,
            accountId,
            column: value
          },
          showToastMessages
        )
      )
    }
    function onChangeSearch(value: React.ReactText) {
      dispatch(
        Actions.onChangeSearch({
          query,
          userName,
          accountId,
          searchValue: value as string
        })
      )
    }

    function getFilterLabelByField(field: string) {
      return find(filterColumns, c => c.value === field)?.label || 'text'
    }

    function onDatesChanged(data: DateRangeData) {
      if (typeof onFetchData === 'function') {
        onFetchData({
          startTime: data.startDate,
          endTime: data.endDate
        })
      }
    }

    const filterColumnValue = selectedFilterColumn
      ? { value: selectedFilterColumn, label: selectedFilterColumn }
      : null
    return (
      <div role={`user_activity_filter`} className={styles.filterUserActivity}>
        {useSearch && (
          <div className={styles.filterSection}>
            <label>Filter:</label>
            <div className={styles.filterSectionBoby}>
              <Select
                role={`user_activity_filter_column`}
                className={styles.filterSelectColumns}
                name={'test'}
                value={filterColumnValue}
                onChange={onChangeFilterColumn}
                isClearable
                options={filterColumns}
              />
              <TextBox
                role={`user_activity_filter_search`}
                className={styles.inputWrapper}
                type="text"
                name="search"
                placeholder={`Enter ${getFilterLabelByField(
                  selectedFilterColumn
                )}...`}
                value={searchValue}
                readOnly={!selectedFilterColumn}
                onChange={onChangeSearch}
              />
            </div>
          </div>
        )}
        <div className={styles.filterSection}>
          <label>Time range:</label>
          <DateRangePicker
            role={`user_activity_filter_date_range`}
            displayFormat={'yyyy-MM-dd hh:mm a'}
            onDatesChanged={onDatesChanged}
            focusedInput={focusedInput}
            startDate={startTime}
            endDate={endTime}
          />
        </div>
      </div>
    )
  }
)

UserActivityFilter.defaultProps = {
  useSearch: true
}
